import { useState, useEffect } from 'react';

export default function DesktopExperienceModal() {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const hasSeen = localStorage.getItem('hasSeenDesktopNotice');
        const isMobile = window.innerWidth < 768;

        // Only show if haven't seen before AND is mobile
        if (!hasSeen && isMobile) {
            setIsOpen(true);
        }
    }, []);

    const handleClose = () => {
        localStorage.setItem('hasSeenDesktopNotice', 'true');
        setIsOpen(false);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/60 backdrop-blur-sm animate-fade-in-up">
            <div className="bg-white dark:bg-slate-900 rounded-2xl p-6 max-w-sm w-full shadow-2xl border border-slate-200 dark:border-slate-800 relative overflow-hidden">
                {/* Decorative background element */}
                <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-violet-500/20 rounded-full blur-2xl pointer-events-none"></div>

                <div className="relative z-10">
                    <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">
                        Desktop Recommended
                    </h3>
                    <p className="text-slate-600 dark:text-slate-300 mb-6 leading-relaxed">
                        This site is designed for desktop for the best experience. Some features may be limited on mobile devices.
                    </p>
                    <button
                        onClick={handleClose}
                        className="w-full btn-primary py-3 text-base shadow-lg shadow-violet-500/25"
                    >
                        Got it
                    </button>
                </div>
            </div>
        </div>
    );
}
